import { useState, useEffect } from 'react';
import { getRedisStatus, redisReconnect } from '../../../api/index.js';

const RedisManager = () => {
  const [redisStatus, setRedisStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchRedisStatus = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await getRedisStatus();
      setRedisStatus(response.data);
    } catch (err) {
      setError('Redis est injoignable.');
      setRedisStatus(null);
    } finally {
      setLoading(false);
    }
  };

  const handleRedisReconnect = async () => {
    if (!window.confirm("Êtes-vous sûr de vouloir redémarrer la connexion Redis ?")) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      await redisReconnect();
      fetchRedisStatus(); // Vérifier si la reconnexion a marché
      alert('Redis a été reconnecté avec succès.');
    } catch (err) {
      setError('Échec de la reconnexion à Redis.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRedisStatus();
  }, []);

  return (
    <div>
      <h3>État de Redis</h3>
      {redisStatus ? (
        <ul>
          <li>🔔 Main Client : {redisStatus.mainClient}</li>
          <li style={{display:'block'}}>[SOCKET CLIENTS]</li>
          <li>📡 Pub Client : {redisStatus.pubClient}</li>
          <li>🔔 Sub Client : {redisStatus.subClient}</li>
        </ul>
      ) : (
        <p style={{ color: 'red' }}>{error || 'Chargement...'}</p>
      )}

      <button onClick={fetchRedisStatus} disabled={loading}>
        {loading ? 'Vérification en cours...' : 'Vérifier Redis'}
      </button>

      <button onClick={handleRedisReconnect} disabled={loading}>
        {loading ? 'Reconnexion en cours...' : 'Reconnecter Redis'}
      </button>
    </div>
  );
};

export default RedisManager;
